import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { CSSTransition, SwitchTransition } from "react-transition-group"
import configs from "../../../../configs"
import { fetchPlansAnswers } from "../../../../services/plans"
import "./styles.scss"

import Header from "../../../../components/Header"
import Footer from "../../../../components/Footer"
import Stepper from "./components/Stepper"

import SupportTeam from "./components/SupportTeam"
import AboutMe from "./components/AboutMe"
import CommunityActivities from "./components/CommunityActivities"
import MyGoals from "./components/MyGoals"
import AddService from "./components/AddService"
import ManagingFunds from "./components/ManagingFunds"
import Review from "./components/Review"

class PrePlan extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      steps: [
        {
          id: 0,
          label: "About Me",
          labelMobile: "Questions",
          children: [0, 1, 2]
        },
        {
          id: 1,
          label: "Support Team",
          url: "support-team",
          step: 0
        },
        {
          id: 2,
          label: "Support Questions",
          url: "about-me",
          step: 1
        },
        {
          id: 3,
          label: "Community Activities",
          url: "community-activities",
          step: 2
        },
        {
          id: 4,
          label: "Setting Goals",
          labelMobile: "Goals",
          children: [3]
        },
        {
          id: 5,
          label: "My Goals",
          url: "my-goals",
          step: 3
        },
        {
          id: 6,
          label: "Required Services",
          labelMobile: "Req Services",
          children: [4, 5]
        },
        {
          id: 7,
          label: "Add A Service",
          url: "add-a-service",
          step: 4
        },
        {
          id: 8,
          label: "Managing Funds",
          url: "managing-funds",
          step: 5
        },
        {
          id: 9,
          label: "Review",
          labelMobile: "Review",
          url: "review",
          step: 6,
          children: []
        }
      ],
      stepsState: true,
      activeStep: 0
    }
  }

  componentDidMount() {
    const {
      store: { plan, user },
      history,
      location,
      onFetchPlansAnswers
    } = this.props

    if (user.list_role.includes(configs.roles.Guardian) && location.state) {
      if (!location.state.planId) {
        history.push(`/`)
      } else {
        onFetchPlansAnswers(user.token, location.state.planId)
      }
    } else if (!plan.id && !plan.loading) {
      history.push(`/`)
    }

    this.changeUrl()
    this.scrollToNav()
  }

  componentDidUpdate(prevProps) {
    const {
      computedMatch,
      store: { plan, user },
      history
    } = this.props

    if (user.list_role.includes(configs.roles.Participant)) {
      if (!plan.id && !plan.loading) {
        history.push(`/`)
      }
    }

    if (prevProps.computedMatch.params.step !== computedMatch.params.step) {
      this.changeUrl()
      this.scrollToNav()
    }
  }

  onGoAt = (url, index, e, id) => {
    const { history, location } = this.props
    const { steps, stepsState } = this.state

    if (e) e.preventDefault()

    this.setState({ activeStep: index, stepsState: !stepsState })

    if (url) {
      if (id !== undefined) {
        history.push({
          pathname: `/pre-plan/${url}/${id}`,
          state: { planId: location.state ? location.state.planId : null }
        })
      } else {
        history.push({
          pathname: `/pre-plan/${url}`,
          state: { planId: location.state ? location.state.planId : null }
        })
      }
    } else {
      const result = steps.find(step => {
        return step.step === index
      })

      history.push({
        pathname: `/pre-plan/${result.url}`,
        state: { planId: location.state ? location.state.planId : null }
      })
    }
  }

  scrollToNav = () => {
    const offSet =
      this.scrollPoint.getBoundingClientRect().top + window.pageYOffset
    const supportsNativeSmoothScroll =
      "scrollBehavior" in document.documentElement.style

    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: offSet,
        behavior: "smooth"
      })
    } else {
      window.scrollTo(0, offSet)
    }
  }

  handleNext = () => {
    const { activeStep, steps, stepsState } = this.state
    const { history, location } = this.props

    const result = steps.find(step => {
      return step.step === activeStep + 1
    })

    this.setState({ activeStep: activeStep + 1, stepsState: !stepsState })

    history.push({
      pathname: `/pre-plan/${result.url}`,
      state: { planId: location.state ? location.state.planId : null }
    })

    this.scrollToNav()
  }

  handleBack = () => {
    const { activeStep, steps, stepsState } = this.state
    const { history, location } = this.props

    const result = steps.find(step => {
      return step.step === activeStep - 1
    })

    history.push({
      pathname: `/pre-plan/${result.url}`,
      state: { planId: location.state ? location.state.planId : null }
    })

    this.setState({ activeStep: activeStep - 1, stepsState: !stepsState })

    this.scrollToNav()
  }

  changeUrl() {
    const {
      computedMatch: { params }
    } = this.props
    const { steps } = this.state

    if (params.step) {
      const result = steps.find(item => {
        return item.url === params.step
      })

      if (result) {
        this.setState({ activeStep: result.step })
      }
    }
  }

  render() {
    const { activeStep, steps, stepsState } = this.state
    const { location, computedMatch } = this.props
    const hasSidebar = new RegExp("^/pre-plan/review", "i").test(
      location.pathname
    )
    const id = computedMatch.params.id ? computedMatch.params.id : ""

    return (
      <div className="main-container main-container--light">
        <Header theme="dark" hideNotifications />

        <div
          className={`content pre-plan ${
            hasSidebar ? "pre-plan--with-sidebar" : ""
          }`}
        >
          <div className="container">
            <div
              ref={el => {
                this.scrollPoint = el
              }}
            />
            <Stepper activeStep={activeStep} onGoAt={this.onGoAt} steps={steps}>
              <div className="row">
                <CSSTransition
                  in={hasSidebar}
                  timeout={300}
                  unmountOnExit
                  classNames="fade"
                  component={null}
                >
                  <div className="col-lg-5 pre-plan_sidebar-wrap">
                    <div className="pre-plan_sidebar">
                      <nav className="pre-plan_sidebar_nav">
                        <div className="pre-plan_sidebar_nav_title">
                          About Me
                        </div>
                        <ul>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("about-me", 0, e)
                              }}
                            >
                              Support Team
                            </a>
                          </li>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("support-team", 1, e)
                              }}
                            >
                              Support Questions
                            </a>
                          </li>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("community-activities", 2, e)
                              }}
                            >
                              Community Activities
                            </a>
                          </li>
                        </ul>

                        <div className="pre-plan_sidebar_nav_title">
                          Support Goals
                        </div>
                        <ul>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("my-goals", 3, e)
                              }}
                            >
                              My Goals
                            </a>
                          </li>
                        </ul>

                        <div className="pre-plan_sidebar_nav_title">
                          Required Services
                        </div>
                        <ul>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("add-a-service", 4, e)
                              }}
                            >
                              Add A Service
                            </a>
                          </li>
                          <li>
                            <a
                              href="/#"
                              onClick={e => {
                                this.onGoAt("managing-funds", 5, e)
                              }}
                            >
                              Managing Funds
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </CSSTransition>

                <div className={hasSidebar ? "col-lg-7" : "col-lg-12"}>
                  <SwitchTransition>
                    <CSSTransition
                      timeout={500}
                      key={stepsState}
                      classNames="fade"
                    >
                      <div className="pre-plan_content">
                        {(() => {
                          switch (activeStep) {
                            case 0:
                              return (
                                <SupportTeam
                                  id={id}
                                  onNext={this.handleNext}
                                  scrollToNav={this.scrollToNav}
                                />
                              )
                            case 1:
                              return (
                                <AboutMe
                                  id={id}
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                  scrollToNav={this.scrollToNav}
                                />
                              )
                            case 2:
                              return (
                                <CommunityActivities
                                  id={id}
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                  scrollToNav={this.scrollToNav}
                                />
                              )
                            case 3:
                              return (
                                <MyGoals
                                  id={id}
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                  scrollToNav={this.scrollToNav}
                                />
                              )
                            case 4:
                              return (
                                <AddService
                                  id={id}
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                  scrollToNav={this.scrollToNav}
                                />
                              )
                            case 5:
                              return (
                                <ManagingFunds
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                />
                              )
                            case 6:
                              return (
                                <Review
                                  onGoAt={this.onGoAt}
                                  onBack={this.handleBack}
                                  onNext={this.handleNext}
                                />
                              )
                            default:
                              return null
                          }
                        })()}
                      </div>
                    </CSSTransition>
                  </SwitchTransition>
                </div>
              </div>
            </Stepper>
          </div>
        </div>

        <Footer />
      </div>
    )
  }
}

PrePlan.propTypes = {
  onFetchPlansAnswers: propTypes.func.isRequired,
  computedMatch: propTypes.shape({
    path: propTypes.string,
    url: propTypes.string,
    params: propTypes.shape({
      step: propTypes.string,
      id: propTypes.oneOfType([propTypes.string, propTypes.number])
    })
  }).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired,
  location: propTypes.shape({
    pathname: propTypes.string,
    state: propTypes.shape({
      from: propTypes.object,
      planId: propTypes.string
    })
  }).isRequired,
  store: propTypes.shape({
    plan: propTypes.shape({
      id: propTypes.string,
      loading: propTypes.bool
    }),
    user: propTypes.shape({
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    })
  }).isRequired
}

const mapStateToProps = ({ PlansReducer, AuthenticationReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onFetchPlansAnswers: (token, planId) =>
    dispatch(fetchPlansAnswers(token, planId))
})

export default connect(mapStateToProps, mapDispatchToProps)(PrePlan)
